namespace Roodik.Core
{
	export class CloudGames extends Advertisment
	{
		constructor(config:IAdvertismentConfig, soundManager:ISoundManager)
		{
			super();

			window["CloudAPI"].init({
				'id': config.id,
				'splash': false
			});

			window["CloudAPI"].mute = ()=>{
				//Call function which will mute ALL sounds of the game, return true if succeed.
				soundManager.muteMusic();
				soundManager.muteSound();
				return true;
			};

			window["CloudAPI"].unmute = ()=>{
				//Call function which will unmute sounds of the game, return true if succeed.
				soundManager.unMuteMusic();
				soundManager.unMuteSound();
				return true;
			};
		}

		public fetch()
		{
			window["CloudAPI"].play();
		}

		public show(force: boolean)
		{
			window["CloudAPI"].gameOver();
		}

		public get available():boolean
		{
			return true;
		}

		private get sdkExist():boolean
		{
			return window["CloudAPI"] !== 'undefined' && window["CloudAPI"] != null;
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Advertisment/CloudGames.ts